import { useCallback, useEffect } from 'react';
import { useSearchParams, useLocation, useNavigate, createSearchParams } from 'react-router-dom';

import { RoutePaths } from '../../constants';
import { searchActions, useSearchSelector } from '../slices';

import { useActions } from './useActions';

export const useSearch = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();

    const { setSearchQuery, syncSearchQuery } = useActions(searchActions);
    const { query } = useSearchSelector();

    const searchQuery = query ?? '';

    const handleSearch = useCallback(
        (query: string) => {
            const trimmedQuery = query.trim();
            const newSearchParams = { q: trimmedQuery };

            setSearchQuery(query);

            if (location.pathname === RoutePaths.Search) {
                setSearchParams(newSearchParams, { replace: true });

                return;
            }

            if (trimmedQuery) {
                navigate({
                    pathname: RoutePaths.Search,
                    search: createSearchParams(newSearchParams).toString(),
                });
            }
        },
        [location.pathname, navigate, setSearchParams, setSearchQuery],
    );

    useEffect(() => {
        const queryFromUrl = searchParams.get('q') ?? '';
        syncSearchQuery(queryFromUrl);
        // Синхронизируем параметры один раз при монтировании
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { searchQuery, handleSearch };
};
